/**
 * Form Textfield component
 *
 * @remarks
 */

import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
  useBreakpointValue,
} from "@chakra-ui/react";
import { HidePasswordIcon, ViewPasswordIcon } from "./HJSIcons";

import { FC, ReactNode, forwardRef, useState } from "react";

export interface ITextField {
  label?: string;
  variant?: "outline" | "filled" | "flushed" | "unstyled";
  placeholder?: string;
  required?: boolean;
  error?: boolean;
  helperText?: string | ReactNode;
  ref?: any;
  type?: string;
  value?: string;
}

const TextField: FC<ITextField> = forwardRef((props: ITextField, ref) => {
  const {
    label,
    placeholder,
    variant,
    error,
    helperText,
    type,
    value,
    ...rest
  } = props;

  const [showPassword, setShowPassword] = useState(type === "password");
  const handleTogglePassword: () => void = () =>
    setShowPassword((passwordVisibilityState) => !passwordVisibilityState);

  const isMobile: boolean = useBreakpointValue({
    base: true,
    md: false,
  }) as boolean;

  return (
    <FormControl
      // isInvalid={!_.isEmpty(errors.firstName) && touched.firstName}
      isInvalid={error}
    >
      <FormLabel
        color="teal.900"
        fontWeight="700"
        fontSize={[14, 14, 18, 24]}
        htmlFor="firstName"
        m={isMobile ? "initial" : ""}
      >
        {label}
      </FormLabel>
      <InputGroup marginTop={-1}>
        <Input
          variant={variant}
          placeholder={placeholder}
          value={value}
          borderBottomWidth="2px"
          borderBottomColor="hjsBlack"
          focusBorderColor="yellow.500"
          errorBorderColor="red.500"
          fontSize={[14, 14, 18]}
          height={isMobile ? 8 : 10}
          ref={ref}
          type={type === "password" && showPassword ? "password" : "text"}
          {...rest}
          // h="1.8rem !important"
        />
        {type === "password" && (
          <InputRightElement top={isMobile ? "-.3rem" : " "}>
            <IconButton
              variant="ghost"
              fill="none"
              aria-label={!showPassword ? "hide password" : "show password"}
              _hover={{ backgroundColor: "transparent" }}
              _active={{ backgroundColor: "transparent" }}
              icon={
                !showPassword ? (
                  <ViewPasswordIcon boxSize={6} />
                ) : (
                  <HidePasswordIcon boxSize={6} />
                )
              }
              onClick={handleTogglePassword}
            />
          </InputRightElement>
        )}
      </InputGroup>

      {Boolean(error) && (
        <FormErrorMessage fontSize={[14, 14, 18]}>
          {helperText}
        </FormErrorMessage>
      )}
    </FormControl>
  );
});

TextField.defaultProps = {
  label: "",
  variant: "flushed",
  error: false,
  helperText: "",
  type: "text",
};

export default TextField;

TextField.displayName = "TextField";
